/* __next_internal_client_entry_do_not_use__ EmbeddedLink auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMaybeDomainStripping } from "@faire/web--source/ui/hooks/useMaybeDomainStripping";
import * as React from "react";
import styled from "styled-components";
import { shouldUseAnchorForLink } from "../lib";
import { Link, Anchor } from "../LinkAnchor";
import { EmbeddedLinkStyles } from "./styles";
var StyledAnchor = styled(Anchor).withConfig({
    componentId: "sc-a63cd680-0"
})([
    "",
    ""
], EmbeddedLinkStyles);
var StyledLink = styled(Link).withConfig({
    componentId: "sc-a63cd680-1"
})([
    "",
    ""
], EmbeddedLinkStyles);
/**
 * @deprecated use slate/Button tertiary variant instead
 */ export var EmbeddedLink = function(props) {
    var linkTo = props.linkTo, children = props.children, onClick = props.onClick, rest = _object_without_properties(props, [
        "linkTo",
        "children",
        "onClick"
    ]);
    var _useMaybeDomainStripping = useMaybeDomainStripping(linkTo, rest.target), _useMaybeDomainStripping_potentiallyRelativeLink = _useMaybeDomainStripping.potentiallyRelativeLink, potentiallyRelativeLink = _useMaybeDomainStripping_potentiallyRelativeLink === void 0 ? linkTo : _useMaybeDomainStripping_potentiallyRelativeLink;
    if (shouldUseAnchorForLink(potentiallyRelativeLink)) {
        return /*#__PURE__*/ _jsx(StyledAnchor, _object_spread_props(_object_spread({}, rest), {
            href: potentiallyRelativeLink,
            onClick: onClick,
            children: children
        }));
    }
    if (!potentiallyRelativeLink) {
        return /*#__PURE__*/ _jsx(StyledAnchor, _object_spread_props(_object_spread({}, rest), {
            onClick: onClick,
            role: "button",
            children: children
        }));
    } else {
        return /*#__PURE__*/ _jsx(StyledLink, _object_spread_props(_object_spread({}, rest), {
            to: potentiallyRelativeLink,
            onClick: onClick,
            children: children
        }));
    }
};
